import { useTheme } from '../context/theme';
import { renderIcon } from '../utils/icons';
import { Card } from './ui';

export default function SiteProgressChart({ siteStats }) {
  const { theme, isDark } = useTheme();
  const sorted = [...(siteStats || [])].sort((a, b) => (b.pct || 0) - (a.pct || 0));

  return (
    <Card>
      <div style={{ fontSize: 16, fontWeight: 400, fontFamily: "'DM Sans', sans-serif", letterSpacing: '-0.01em', color: theme.text, marginBottom: 14 }}>Site Progress</div>
      {sorted.length === 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '16px 0', textAlign: 'center' }}>
          <div style={{ fontSize: 24, marginBottom: 6, opacity: 0.7 }}>{renderIcon('hard-hat', 24)}</div>
          <div style={{ color: theme.textSecondary, fontSize: 13 }}>No site data</div>
        </div>
      )}
      {sorted.map(s => (
        <div key={s.siteName} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
          <div style={{ width: 120, fontSize: 13, color: theme.textSecondary, flexShrink: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.siteName}</div>
          <div style={{ flex: 1, height: 16, background: isDark ? 'rgba(255,255,255,0.10)' : 'rgba(0,0,0,0.08)', borderRadius: 4, overflow: 'hidden', margin: '0 10px' }}>
            <div style={{ width: (s.pct || 0) + '%', height: '100%', background: 'linear-gradient(90deg,#4ADE80,#4ADE80)', borderRadius: 4, transition: 'width .4s' }} />
          </div>
          <div style={{ width: 36, fontSize: 13, color: theme.text, textAlign: 'right', flexShrink: 0 }}>{s.pct || 0}%</div>
        </div>
      ))}
    </Card>
  );
}
